import { render, staticRenderFns } from "./AssetStatistic.vue?vue&type=template&id=26c94f5a"
import script from "./AssetStatistic.vue?vue&type=script&lang=js"
export * from "./AssetStatistic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports